import React from "react";
import { FormProvider } from "react-hook-form";
import { FormHelperText, Grid, Stack, Typography } from "@mui/material";

import { RFHfileInput as RHFFileInputButton } from "../../../components/RFH";
import { getAPIBaseUrl } from "../../../utils/constants";
import { useAssets } from "../../../reactQuery/domainAssets";
import Pensil from "../../../styles/svg/pensil.svg";
import TenantSiteName from "../../../components/TenantSiteName";
import { CustomButton } from "../../../components/Button/Button";
import { useLogoForm } from "./hooks/useLogoForm";

function BrandingLogo() {
  const { methods, isPending, isFieldFilled, handleSubmit } = useLogoForm();
  const { watch } = methods;
  const logoBlob = watch("logo");
  const feviconBlob = watch("favicon");
  const apiUrl = getAPIBaseUrl();
  const { logo, icon } = useAssets();

  return (
    <>
      <FormProvider {...methods}>
        <div className="mt-32 form-section  ">
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            <div>
              <Typography className="setting-heading mb-4 ml-0">
                Branding
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <div className="flex-grow-1">
                    <Typography>Logo</Typography>
                    <Stack direction="row" className="branding-cont">
                      <Stack className="branding-icon-cont">
                        {logo || logoBlob ? (
                          <img
                            src={
                              logoBlob
                                ? URL.createObjectURL(logoBlob)
                                : `${apiUrl}/${logo}`
                            }
                            alt="logo"
                          />
                        ) : (
                          <TenantSiteName />
                        )}
                      </Stack>
                      <div className="logos-pensil">
                        <RHFFileInputButton
                          name="logo"
                          label=""
                          showError={false}
                          accept="image/*"
                        >
                          <img src={Pensil} className="cursor-pointer" alt="edit logo" />
                        </RHFFileInputButton>
                      </div>
                    </Stack>
                  </div>
                  <div className="mt-1">
                    {methods.formState.errors.logo && (
                      <FormHelperText error={true}>
                        {methods.formState.errors.logo.message}
                      </FormHelperText>
                    )}
                    <Typography className="logo-note">
                      Please upload image size less than 200KB.
                    </Typography>
                    <div>
                      <CustomButton
                        variant="contained"
                        type="submit"
                        sx={{ padding: "8px 32px" }}
                        className="theme-bg-color"
                        disabled={isPending || !isFieldFilled("logo")}
                      >
                        Save
                      </CustomButton>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div className="flex-grow-1">
                    <Typography>Favicon</Typography>
                    <Stack direction="row" className="branding-fav-cont">
                      <Stack className="branding-favicon-cont">
                        <img
                          src={
                            feviconBlob
                              ? URL.createObjectURL(feviconBlob)
                              : `${apiUrl}/${icon}`
                          }
                          alt="logo"
                        />
                      </Stack>
                      <div className="logos-pensil">
                        <RHFFileInputButton
                          name="favicon"
                          label=""
                          showError={false}
                          accept="image/*"
                        >
                          <img src={Pensil} className="cursor-pointer" alt="edit favicon" />
                        </RHFFileInputButton>
                      </div>
                    </Stack>
                  </div>
                  <div className="mt-1">
                    {methods.formState.errors.favicon && (
                      <FormHelperText error={true}>
                        {methods.formState.errors.favicon.message}
                      </FormHelperText>
                    )}
                    <Typography className="logo-note">
                      Upload a 30x30 pixel ICO,PNG to display in browser tab.{" "}
                    </Typography>
                    <div>
                      <CustomButton
                        variant="contained"
                        type="submit"
                        sx={{ padding: "8px 32px" }}
                        className="theme-bg-color"
                        disabled={isPending || !isFieldFilled("favicon")}
                      >
                        Save
                      </CustomButton>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </form>
        </div>
      </FormProvider>
    </>
  );
}

export default React.memo(BrandingLogo);
